@@ -0,0 +1,78 @@
<template>
  <div>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :showSelect="false"
      :rowActions="rowActions"
      identifier="plansFeesConfigurationTable"
      @error="error = $event"
    ></pbas-data-table>
    <plan-fees-configuration-dialog
      :model="dialog"
      :value="selected"
      @close="onClose"
      @saved="onSaved"
    />
    <error-handler :error="error"></error-handler>
    <v-snackbar
      v-model="snackbar"
      color="success"
      :multi-line="false"
      :timeout="2500"
      :vertical="false"
    >
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/PlanFeesConfiguration";
import PlanFeesConfigurationDialog from "@/components/PlanFeesConfiguration/PlanFeesConfigurationDialog.vue";
import ErrorHandler from "@/components/ErrorHandler";
import { mapActions } from "vuex";
export default {
  components: {
    PlanFeesConfigurationDialog,
    ErrorHandler,
  },
  props: ["brokerId"],
  data() {
    return {
      snackbar: false,
      error: null,
      provider: undefined,
      dialog: false,
      selected: null,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.loadItem(item.CurrentPlanFee.Id),
        },
      ],
      loading: false,
    };
  },
  mounted() {
    this.provider = new ODataProvider(
      this.$axiosHttp,
      "brokers/" + this.brokerId + "/plan-fees-configuration",
      getHeaders()
    );
  },
  methods: {
    ...mapActions("plansMembers", ["getPlanFeeConfigurationById"]),
    async loadItem(id) {
      this.loading = true;
      try {
        this.selected = (await this.getPlanFeeConfigurationById({
          id: id,
        })).data.value[0];
        this.dialog = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    onClose() {
      this.dialog = false;
      this.selected = null;
    },
    onSaved() {
      this.onClose();
      this.snackbar = true;
      this.$refs.table.getDataAsync();
    },
  },
};
</script>
